import i18n from 'i18next';
import React from 'react';
import {SwList} from 'simplifyworks-core-ui';

const TemporaryUserList = () => {
	return (
		<SwList
			name='foedus-contacts-temporary-users-list'
			restPrefix='/api/foedus/contacts/temporary-users'
			removable={false}
			defaultOrdering={[{property: 'accessExpiration', order: 'desc'}]}
		>
			<SwList.Table minWidth='480px'>
				<SwList.String
					property='user.username'
					labelKey='foedus-temporary-user-username'
					pathProperty='id'
					pathFunc={resource => '/contacts/temporary-users/' + resource.id}
					width='40%'
				/>

				<SwList.Boolean
					property='user.active'
					labelKey='core-user-active'
					width='120px'
				/>

				<SwList.Boolean
					property='accessExpired'
					labelKey='foedus-temporary-user-access-expired'
					width='150px'
				/>

				<SwList.Datetime
					property='accessExpiration'
					labelKey='foedus-temporary-user-access-expiration'
					timeEnabled
					width='220px'
				/>
			</SwList.Table>

			<SwList.Info />
			<SwList.Pagination />
		</SwList>
	);
};

export default {
	title: () => i18n.t('foedus-contacts-temporary-users-title-list'),
	main: TemporaryUserList
};
